import IconButton from '@material-ui/core/IconButton';
import LaunchIcon from '@material-ui/icons/Launch';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {
  ApplStatusEntity,
  ClassEntity,
  CourseEntity,
  SeasonEntity,
  UniversityEntity,
  UniversityTermEntity,
  VseApplicationEntity
} from 'vse-material-ui';

export interface MyApplListProps {
  data: VseApplicationEntity[],
  getApplStatus: (applStatus: string) => ApplStatusEntity | undefined,
  getSeason: (seasonID: number) => SeasonEntity | undefined,
  getUniversity: (universityID: number) => UniversityEntity | undefined,
  getUniversityTerm: (universityID: number, seasonID: number, termCode: string) => UniversityTermEntity | undefined,
  getClass: (classID: number) => ClassEntity | undefined,
  getCourse: (universityID: number, seasonID: number, termCode: string, courseCode: string) => CourseEntity | undefined,
}

export function MyApplList(props: MyApplListProps) {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell style={{ display: 'none' }} />
          <TableCell>Application No.</TableCell>
          <TableCell>VSE Season</TableCell>
          <TableCell>Course Offering University</TableCell>
          <TableCell>Course Offering Term</TableCell>
          <TableCell>Course Code</TableCell>
          <TableCell>Course Title</TableCell>
          <TableCell>Class</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>Submission Date</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {props.data.map(e => {
          const cls = props.getClass(e.classes[0].classID); // Only the first
          const season = props.getSeason(e.seasonID);
          const seasonDescr = season ? season.shortDescription : null;
          const univ = cls ? props.getUniversity(cls.universityID) : null;
          const univName = univ ? univ.universityName : null;
          const univTerm = cls ? props.getUniversityTerm(cls.universityID, cls.seasonID, cls.termCode) : null;
          const univTermDescr = univTerm ? univTerm.shortDescription : null;
          const course = cls ? props.getCourse(cls.universityID, cls.seasonID, cls.termCode, cls.courseCode) : null;
          const courseTitle = course ? course.courseTitle : null;
          const applStatus = props.getApplStatus(e.status);
          return (
            <TableRow key={e.applicationID}>
              <TableCell style={{ display: 'none' }} variant="head" scope="row" padding="checkbox"><IconButton color='secondary'><LaunchIcon /></IconButton></TableCell>
              <TableCell>{e.referenceNumber}</TableCell>
              <TableCell>{seasonDescr}</TableCell>
              <TableCell>{univName}</TableCell>
              <TableCell>{univTermDescr}</TableCell>
              <TableCell>{cls ? cls.courseCode : null}</TableCell>
              <TableCell>{courseTitle}</TableCell>
              <TableCell>{cls ? cls.className : null}</TableCell>
              <TableCell>{applStatus ? applStatus.description : null}</TableCell>
              {/* TODO: Date format */}
              <TableCell>{e.submissionDate ? new Intl.DateTimeFormat('en-CA', { day: "numeric", month: "short", year: "numeric", hour: "2-digit", hour12: false, minute: "2-digit", second: undefined }).format(new Date(e.submissionDate)).replace(',', '') : undefined}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
